package com.karyadina.ui.screens.studyPlanner.components

import androidx.compose.foundation.background
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.LocalFireDepartment
import androidx.compose.material.icons.filled.Timer
import androidx.compose.material.icons.filled.Today
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.karyadina.model.StudyStats
import kotlin.math.round
// import com.karyadina.ui.screens.format
//
//@Composable
//fun StudyStatsRow(stats: StudyStats, modifier: Modifier = Modifier) {
//    Row(
//        modifier = modifier
//            .fillMaxWidth()
//            .horizontalScroll(rememberScrollState()),
//        horizontalArrangement = Arrangement.spacedBy(12.dp)
//    ) {
//        // FIX: Added .format(1) to all values
//        StudyStatCard("Today", "${stats.todayHours.format(1)}h", Icons.Filled.Today)
//        StudyStatCard("Week", "${stats.weekHours.format(1)}h", Icons.Filled.CalendarMonth)
//        StudyStatCard("Streak", "${stats.currentStreak}d", Icons.Filled.LocalFireDepartment)
//        StudyStatCard("Total", "${stats.totalHours.format(1)}h", Icons.Filled.Timer)
//    }
//}
//
//
fun Float.format(digits: Int): String {
    // If value is small (less than 0.1h = 6 mins) but not 0, show minutes
    if (this > 0 && this < 0.1f) {
        val minutes = (this * 60).toInt()
        return "${minutes}m"
    }
    // KMP safe formatting for simple stats (1 decimal place)
    val multiplier = 10.0f
    val rounded = round(this * multiplier) / multiplier
    return rounded.toString() + "h"
}

@Composable
fun StatisticsSectionContainer(stats: StudyStats) {
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 8.dp)
            .background(
                Brush.horizontalGradient(
                    colors = listOf(
                        MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.5f),
                        MaterialTheme.colorScheme.secondaryContainer.copy(alpha = 0.5f),
                        MaterialTheme.colorScheme.tertiaryContainer.copy(alpha = 0.5f)
                    )
                ),
                shape = MaterialTheme.shapes.large
            ),
        color = Color.Transparent,
        shape = MaterialTheme.shapes.large
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Icon(Icons.AutoMirrored.Filled.TrendingUp, null, tint = MaterialTheme.colorScheme.primary)
                Text(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.StatsTitle), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            }
            Spacer(Modifier.height(12.dp))
            Row(
                modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                // Applied .format(1) here
                StudyStatCard(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.StatsToday), stats.todayHours.format(1), Icons.Filled.Today)
                StudyStatCard(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.StatsWeek), stats.weekHours.format(1), Icons.Filled.CalendarMonth)
                StudyStatCard(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.StatsStreak), "${stats.currentStreak}d", Icons.Filled.LocalFireDepartment)
                StudyStatCard(org.jetbrains.compose.resources.stringResource(com.karyadina.ui.theme.StudyStrings.StatsTotal), stats.totalHours.format(1), Icons.Filled.Timer)
            }
        }
    }
}

@Composable
fun StudyStatCard(title: String, value: String, icon: androidx.compose.ui.graphics.vector.ImageVector) {
    ElevatedCard(modifier = Modifier.width(140.dp).height(140.dp)) {
        Box(
            modifier = Modifier.fillMaxSize().background(
                Brush.verticalGradient(listOf(MaterialTheme.colorScheme.surface, MaterialTheme.colorScheme.surfaceVariant.copy(0.3f)))
            ),
            contentAlignment = Alignment.Center
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Box(Modifier.size(48.dp).clip(CircleShape).background(MaterialTheme.colorScheme.primaryContainer.copy(0.5f)), contentAlignment = Alignment.Center) {
                    Icon(icon, null, tint = MaterialTheme.colorScheme.primary, modifier = Modifier.size(24.dp))
                }
                Spacer(Modifier.height(8.dp))
                Text(value, style = MaterialTheme.typography.headlineMedium, fontWeight = FontWeight.ExtraBold, color = MaterialTheme.colorScheme.primary)
                Text(title, style = MaterialTheme.typography.labelMedium, color = MaterialTheme.colorScheme.onSurface.copy(0.7f))
            }
        }
    }
}